module.exports = __webpack_public_path__ + "img/fig23.d5cb3a68.jpg";